"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//tslint:disable:no-reserved-keywords
var Actions;
(function (Actions) {
    Actions["update"] = "feedback.update";
    Actions["send"] = "feedback.send";
})(Actions = exports.Actions || (exports.Actions = {}));
function updateFeedback(feedback) {
    return { type: Actions.update, feedback: feedback };
}
exports.updateFeedback = updateFeedback;
function sendFeedback(feedback) {
    return { type: Actions.send, feedback: feedback };
}
exports.sendFeedback = sendFeedback;
//# sourceMappingURL=feedback.js.map